import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import * as actions from "../common/actions";
import GrowthRateSearchForm from "../components/SOD/MarketShare/GrowthRate/GrowthRateSearchForm";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (filterField: string, value: string | number) => {
      dispatch(actions.updateFilter(filterField, value));
    },
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GrowthRateSearchForm);
